import growl from "utils/growl";
import PropTypes from "prop-types";
import React from "react";

/**
 * Component for replacing inline script tags for growl alerts and notices in HTML/ERB.
 * NOTICE: This is not meant to be used inside React components. Use the growl utility instead.
 *
 * @example
 *   <%= react_component("Growl.Notice", message: "Hello world", options: { delay: 10000 }) %>
 */
const Growl = {
  /**
   * Calls the growl.alert when the component mounts from HTML/ERB.
   *
   * @param {object} props The component props
   * @param {string} props.message The growl alert message
   * @param {object} props.options The options passed into growl
   * @returns {null} Renders nothing
   */
  Alert({ message, options }) {
    growl.alert(message, options);

    return null;
  },

  /**
   * Calls the growl.notice when the component mounts from HTML/ERB.
   *
   * @param {object} props The component props
   * @param {string} props.message The growl notice message
   * @param {object} props.options The options passed into growl
   * @returns {null} Renders nothing
   */
  Notice({ message, options }) {
    growl.notice(message, options);

    return null;
  }
};

Growl.propTypes = {
  message: PropTypes.string.isRequired,
  options: PropTypes.object
};

Growl.Alert.propTypes = Growl.propTypes;
Growl.Notice.propTypes = Growl.propTypes;

export default Growl;
